import BasicSearchForm from '../../types/IBasicSearchForm';

export default {
  query: '',
  sort: 'Best Match',
  accountId: '',
  lastActive: 'Within 3 Months',
  distanceString: '',
  page: 1,
  pageSize: 50,
  countrySelect: 'UKEur',
  sortDirection: 'desc',
  locations: [],
  locationString: '',
} as BasicSearchForm;
